module.exports = __webpack_public_path__ + "assets/2023bbea86337edfa08a7b14bf5ad347.png";